<template>
  <div>
    <upload-file-form
      v-if="podeAnexar"
      ref="uploadArquivo"
      :id="!!idContrato ? idContrato : 600"
      :id-entidade="!!idContrato ? idContrato : 600"
      :title="$t('label.upload_anexo')"
      :url="uriUpload"
      :auto-process-queue="!uploadMultiple"
      :upload-multiple="uploadMultiple"
      @UPLOADFILE_SENDING="enviandoArquivo"
      @UPLOADFILE_SENDING_MULTIPLE="enviandoMultiplosArquivos"
      @UPLOADFILE_FILE_ADDED="preencherDescricaoComNomeArquivo"
      @UploadArquivo__success="uploadSucesso"
      @UPLOADFILE_SUCCESS_MULTIPLE="uploadSucessoMultiplo">
      <v-text-field
        v-if="!uploadMultiple"
        v-model="descricaoArquivo"
        :rules="[rules.required]"
        :counter="150"
        maxlength="150"
        :label="`${$t('label.descricao')}*`"
        required
      ></v-text-field>
    </upload-file-form>

    <div class="painel-anexo">
      <v-row>
        <div :disabled="!podeAnexar" class="botao-anexar">
          <v-btn icon
            @click="() => $refs.uploadArquivo.open()">
            <v-icon>
              attach_file
            </v-icon>
          </v-btn>
        </div>
        <span v-if="novoContrato || isCopiaContrato" style="color: darkorange;" class="ma-3 ml-7">
          {{$t('message.upload_anexo_contrato_indisponivel')}}
        </span>
        <list-files
          :habilitar-exclusao="podeAnexar"
          v-if="!novoContrato && !isCopiaContrato"
          ref="listFiles"
          :uri="uri"
          @ListFiles__arquivos="(files) => $emit('FormAnexoArquivo__qtde', files.length)"></list-files>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import UploadFileForm from '@/shared-components/upload/UploadFileForm';
import basePath from '@/common/functions/api-resource';
import ListFiles from '@/shared-components/files/ListFiles';

export default {
  name: 'PlanejamentoContratoFormAnexoArquivo',
  components: {
    UploadFileForm,
    ListFiles,
  },
  props: {
    idContrato: {
      type: Number,
      default: null,
    },
    isCopiaContrato: Boolean,
    novoContrato: Boolean,
  },
  data() {
    return {
      descricaoArquivo: null,
      uploadMultiple: true,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    uri() {
      const urlUpload = basePath('job', 'arquivo/contrato');
      return `${urlUpload}/${this.idContrato}`;
    },
    uriUpload() {
      const urlUpload = basePath('job', 'arquivo/contrato');
      if (this.uploadMultiple) {
        return `${urlUpload}/${this.idContrato}/upload-multiplo`;
      }
      return `${urlUpload}/${this.idContrato}/upload`;
    },
    hasRole() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'CONTRATO_CRUD' || el === 'CONT_UPLOAD_ARQ').length;
    },
    podeAnexar() {
      return !this.novoContrato && !this.isCopiaContrato && this.hasRole;
    },
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      if (this.uploadMultiple) {
        return;
      }

      formData.append('descricao', encodeURI(this.descricaoArquivo));
    },
    enviandoMultiplosArquivos(files, xhr, formData) {
      files.forEach((file) => {
        const indexUltimoPonto = file.name.lastIndexOf('.');
        const nomeArquivo = file.name.substring(0, indexUltimoPonto);
        const extensaoArquivo = file.name.substring(indexUltimoPonto);

        const novaDescricao = `${nomeArquivo}-${this.idContrato}${extensaoArquivo}`;
        formData.append(`descricoes[${file.name}]`, encodeURI(novaDescricao));
      });
    },
    preencherDescricaoComNomeArquivo(file) {
      if (this.uploadMultiple) {
        return;
      }

      this.descricaoArquivo = file.name;
    },
    uploadSucesso() {
      if (this.uploadMultiple) {
        return;
      }

      setTimeout(() => this.$refs.listFiles.refresh(), 1E3);
      this.$toast(this.$tc('label.upload_arquivo_sucesso', 1));
    },
    uploadSucessoMultiplo() {
      setTimeout(() => this.$refs.listFiles.refresh(), 1E3);
      this.$toast(this.$tc('label.upload_arquivo_sucesso', 2));
    },
  },
};
</script>
<style scoped>
.anexo-desabilitado {
  padding: 12px 0 0 12px;
  font-size: 16px !important;
  color: red;
}
.painel-anexo .container.mx-0 {
  max-width: 97% !important;
}
</style>
